export default history => {
  const { pushState } = history
  history.pushState = function(state) {
    if (typeof history.onpushstate == 'function') {
      history.onpushstate({ state: state })
    }
    return pushState.apply(history, arguments)
  }
}
